import { useTheme, useThemeMode } from "../styles/theme";
import { useApp } from "../context/AppContext";
import { dispDate } from "../utils/dates";

export default function Header() {
  const S = useTheme();
  const { mode, toggleMode } = useThemeMode();
  const { authUser, handleLogout, pendingVendor, overdueDebts, TODAY } = useApp();

  const isDark = mode === "dark";

  return (
    <header style={S.header}>
      <div style={S.headerInner}>
        <div>
          <div style={S.logo}>
            <span style={S.logoIcon}>₹</span>
            <span style={S.logoText}>ProfitLens</span>
          </div>
          <div style={S.headerSub}>
            Daily P&amp;L · Opening Balance · EOD Cash · Debt Manager
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <div style={S.headerDate}>
            <div style={S.dateLabel}>Today</div>
            <div style={S.dateValue}>{dispDate(TODAY)}</div>
            {(pendingVendor.length > 0 || overdueDebts.length > 0) && (
              <div style={S.alertBadge}>
                ⚠ {pendingVendor.length + overdueDebts.length} alert
                {pendingVendor.length + overdueDebts.length > 1 ? "s" : ""}
              </div>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              gap: 4,
            }}
          >
            <div style={{ fontSize: 12, color: S.colors.textDim, fontWeight: 600 }}>
              {authUser?.name || authUser?.email}
            </div>
            <div style={{ display: "flex", gap: 6 }}>
              <button
                onClick={toggleMode}
                title={isDark ? "Switch to light mode" : "Switch to dark mode"}
                style={{
                  background: S.colors.btnGhost,
                  border: `1px solid ${S.colors.inputBorder}`,
                  color: S.colors.textMuted,
                  borderRadius: 6,
                  padding: "5px 10px",
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: "pointer",
                  lineHeight: 1,
                }}
              >
                {isDark ? "☀️" : "🌙"}
              </button>
              <button
                onClick={handleLogout}
                style={{
                  background: S.colors.btnGhost,
                  border: `1px solid ${S.colors.inputBorder}`,
                  color: S.colors.textMuted,
                  borderRadius: 6,
                  padding: "5px 12px",
                  fontSize: 11,
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
